import { render, staticRenderFns } from "./ViewUnderwriter.vue?vue&type=template&id=647cb953&scoped=true"
import script from "./ViewUnderwriter.vue?vue&type=script&lang=js"
export * from "./ViewUnderwriter.vue?vue&type=script&lang=js"
import style0 from "./ViewUnderwriter.vue?vue&type=style&index=0&id=647cb953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647cb953",
  null
  
)

export default component.exports